import React from "react";

const Favourites = () => {
  return <div className="min-h-screen"></div>;
};

export default Favourites;
